export enum DriveBaseTag {
  Folder = 'Folder',
  File = 'File',
  Name = 'Name'
}

export const DriveBaseTagsMap = new Map<DriveBaseTag, { tag: string; prop: string }>([
  [DriveBaseTag.Folder, { tag: 'Folder', prop: 'Type' }],
  [DriveBaseTag.File, { tag: 'File', prop: 'Type' }],
  [DriveBaseTag.Name, { tag: 'Name', prop: 'Name' }]
]);
